module.exports = __webpack_public_path__ + "img/headBg2.9893a2be.jpg";